export function StorageTabSkeleton() {
    return (
        <div className="flex flex-col gap-6 pt-14">
            <div className="h-[52px] w-full skeleton-item rounded-md" />
            <div
                className="grid gap-4"
                style={{
                    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                }}
            >
                {[1, 2].map((i) => (
                    <div
                        key={i}
                        className="skeleton-item-container border border-grey-600 rounded-[10px] p-4 flex flex-col gap-3"
                    >
                        <div className="h-4 w-32 skeleton-item rounded" />
                        <div className="h-7 w-24 skeleton-item rounded" />
                        <div className="h-4 w-56 skeleton-item rounded" />
                        <div className="h-3 w-40 skeleton-item rounded" />
                    </div>
                ))}
            </div>
        </div>
    );
}
